import React from 'react';
import classNames from 'classnames';
import style from './ModalWrapper.module.scss';

interface IProps {
	children: React.ReactNode;
	isVisible: boolean;
	className?: string;
}

export const ModalWrapper: React.FC<IProps> = ({ children, isVisible, className }) => {
	const containerClasses = classNames(style.container, { [style.visible]: isVisible }, className);

	return (
		<div className={containerClasses} data-test="ModalWindows">
			{children}
		</div>
	);
};
